const subMenuVisibleKey = 'MAGIC_SUB_MENU_VISIBLE';

export function saveSubMenuVisible(isVisible: boolean) {
    if (isVisible) {
        sessionStorage.setItem(subMenuVisibleKey, '1');
    } else {
        sessionStorage.removeItem(subMenuVisibleKey);
    }
}
 
export function getSubMenuVisible() {
    return sessionStorage.getItem(subMenuVisibleKey) === '1';
}
